module.exports = __webpack_public_path__ + "img/bcc028.61ff0675.jpeg";